
  import React from "react"
  import Component from "/Users/wbm/dev/KRATOS/kratos_landing/src/layouts/index.js"
  import data from "/Users/wbm/dev/KRATOS/kratos_landing/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js